import { Button, Dialog, Input } from "@z/ui";
import { deriveTitle } from "@hq/core";
import { useState } from "react";

export function ExtractNoteDialog({
  text,
  onMove,
  onClose,
  busy,
}: {
  text: string;
  busy: boolean;
  onMove: (title: string) => void;
  onClose: () => void;
}) {
  const [title, setTitle] = useState(deriveTitle(text));
  return (
    <Dialog.Root
      open
      onOpenChange={(open) => {
        if (!open && !busy) onClose();
      }}
    >
      <Dialog.Content className="max-w-[calc(100%-2rem)] sm:max-w-md" showClose={!busy}>
        <Dialog.Header>
          <Dialog.Title>Move to a new note</Dialog.Title>
          <Dialog.Description>
            Your selection becomes a note in the same folder. A link stays here.
          </Dialog.Description>
        </Dialog.Header>
        <form
          className="flex flex-col gap-4"
          onSubmit={(event) => {
            event.preventDefault();
            if (title.trim() && !busy) onMove(title);
          }}
        >
          <label className="flex flex-col gap-1.5 text-sm">
            Note title
            <Input
              autoFocus
              value={title}
              disabled={busy}
              onChange={(e) => setTitle(e.target.value)}
            />
          </label>
          <div className="max-h-40 overflow-auto whitespace-pre-wrap rounded-md bg-surface p-3 text-sm text-fg-muted">
            {text}
          </div>
          <Dialog.Footer>
            <Button variant="ghost" disabled={busy} onClick={onClose}>
              Cancel
            </Button>
            <Button type="submit" disabled={busy || !title.trim()}>
              {busy ? "Moving…" : "Move selection"}
            </Button>
          </Dialog.Footer>
        </form>
      </Dialog.Content>
    </Dialog.Root>
  );
}
